import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {closeModal, mostrarToast, openModal} from "../../../utils/utilities";
import {GET_ALL_DATA_SUCURSAL_HORARIO} from "../../../graphql/graphql.queris";
import {AuthService} from "../../../auth/auth.service";
import {Apollo} from "apollo-angular";
import {NgForOf} from "@angular/common";


@Component({
  selector: 'app-horario-nav-bar',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './horario-nav-bar.component.html',
  styleUrl: './horario-nav-bar.component.css'
})
export class HorarioNavBarComponent implements OnInit{
  @ViewChild('modalSucursalSelect') modalSucursalSelect!: ElementRef;
  sucursalActual: string = '';
  horarioEsActual= '';
  horarioSabadoActual= '';
  horarioDomingoActual= '';
  sucursales: any[] = [];

  constructor(
    private authService: AuthService,
    private apollo: Apollo,
  ) {
  }

ngOnInit() {

    this.getAllDataSucursalHorario();




  }

  getAllDataSucursalHorario() {
    try {
      const token = this.authService.getToken();
      this.apollo.query({
        query: GET_ALL_DATA_SUCURSAL_HORARIO,
        context: {
          headers: {
            Authorization: `Bearer ${this.authService.getToken()}`
          }
        },
        fetchPolicy: 'network-only'
      }).subscribe((result: any) => {
        this.sucursales = result.data.getAllDataHorarios;
        this.sucursalActual = this.sucursales[0].nameSucursal;
        this.horarioEsActual = this.sucursales[0].horarioEntreSemana;
        this.horarioSabadoActual = this.sucursales[0].horarioSabado;
        this.horarioDomingoActual = this.sucursales[0].horarioDomingo;
        // mostrarToast('Los datos han sido actualizados', true, this.serviceNotification);

      })


    } catch (e) {
      console.log(e)
    }
  }

  //*ngFor="let item of sucursales"

  updateSucursalHorario(item: any) {
    this.sucursalActual = item.nameSucursal;
    this.horarioEsActual = item.horarioEntreSemana;
    this.horarioSabadoActual = item.horarioSabado;
    this.horarioDomingoActual = item.horarioDomingo;
    this.closeModal();
  }

  mostrarModal(){
    openModal(this.modalSucursalSelect);
  }
  closeModal(){
    closeModal(this.modalSucursalSelect);
  }

}
